import React, { useEffect, useState } from 'react';
import { getCourses } from '@yandex-int/k-common/client/api/defs/get-courses';
import { Course } from '@yandex-int/k-common/typings';
import { differenceInDays } from 'date-fns';
import { showOtklick } from '@edu-frontend/modules/src/shared/lib/otklickWidget';
import { actions as feedbackActions } from '@edu-frontend/modules/src/shared/lib/uxFeedbackWidget';
import { wrapError } from '@edu-frontend/modules/src/shared/lib/error';

export const TeacherOtcklickNewClass = () => {
    const [courses, setCourses] = useState<Course[]>([]);

    useEffect(() => {
        const fetchCourses = async () => {
            try {
                const allCourses = await getCourses();
                setCourses(allCourses);
            } catch (err) {
                window.Ya.Rum.logError({ message: 'Error getCourses' }, wrapError(err));
            }
        };

        fetchCourses();
    }, []);

    const informaticsCourses = courses.filter((course) => course.subject === 'informatics');

    const today = new Date();

    const allNewInformaticsClasses =
        informaticsCourses.length > 0 &&
        informaticsCourses
            .filter(({ teams }) => teams.length > 0)
            .every(({ date_created }) => {
                const dateCreateClass = new Date(date_created);
                const diffDays = differenceInDays(today, dateCreateClass);

                // прошло не более трех дней после создания класса
                return Math.abs(diffDays) <= 3;
            });

    useEffect(() => {
        if (allNewInformaticsClasses) {
            showOtklick(feedbackActions.CREATE_CLASS_NEW, (err) => {
                window.Ya.Rum.logError(
                    { message: `Otklick error: ${feedbackActions.CREATE_CLASS_NEW}` },
                    wrapError(err)
                );
            });
        }
    }, [allNewInformaticsClasses]);

    return <></>;
};
